import Dropdown from "app/components/Dropdown";
import { CogIcon, DuplicateIcon, Menu } from "app/components/Icons";
import React, { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useBoardsActions } from "../useBoardsActions";

export default function SettingsButton() {
  const location = useLocation();
  const pathName = location.pathname;
  const params = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const { toggleBoardSetting } = useBoardsActions(params?.project as string);
  const options = [
    {
      label: "Settings",
      value: "settings",
      icon: <CogIcon size={20} color="#79808A" />,
      action: () => toggleBoardSetting(true),
      isVisible: true,
    },
    {
      label: "Duplicate",
      value: "duplicate",
      icon: <DuplicateIcon size={20} color="#79808A" />,
      action: () => {},
      isVisible: !pathName?.endsWith("/backlog") ? true : false,
    },
  ];

  const MenuItems = options
    .filter((x) => x.isVisible)
    ?.map((ele) => {
      if (ele)
        return {
          label: (
            <>
              <div className={`flex items-start gap-3 p-1 w-[100%]`}>
                <div className="min-w-[20px]">{ele.icon}</div>

                <div className="text-sm leading-[18px] font-normal text-black text-ellipsis overflow-hidden whitespace-nowrap">
                  {ele.label}
                </div>
              </div>
            </>
          ),
          action: () => {
            ele.action();
          },
        };
      else return { label: "", action: () => {} };
    });

  return (
    <Dropdown
      open={isOpen}
      setOpen={() => setIsOpen(!isOpen)}
      trigger={
        <button
          className={`w-[24px] h-[24px] flex items-center justify-center hover:bg-[#E9ECF2] focus:outline-none outline-none ${
            isOpen
              ? "border-[0.8px] border-[rgba(121, 128, 138, 1)] rounded"
              : ""
          }`}
        >
          <Menu />
        </button>
      }
      align="end"
      menuItems={MenuItems}
      className="!w-[150px] py-2"
    />
  );
}
